// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TogetherActivityControlPage {
  padding-left: 281px;
  background: #eff0f4;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}
.TogetherActivityControlPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 43px 40px 27px;
  box-sizing: border-box;
}
.TogetherActivityControlPage .titleBlock h1 {
  margin: 0;
  font-family: "Montserrat Regular", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #2c274b;
}
.TogetherActivityControlPage__content {
  padding: 32px 40px 48px;
  max-width: 1100px;
}
.TogetherActivityControlPage__card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(44, 39, 75, 0.06);
}
.TogetherActivityControlPage .ant-table {
  font-size: 14px;
}
.TogetherActivityControlPage .ant-table-thead > tr > th {
  font-weight: 600;
  color: #2c274b;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/TogetherActivityControlPage/TogetherActivityControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AACI;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACN;AAGE;EACE,uBAAA;EACA,iBAAA;AADJ;AAIE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAME;EACE,gBAAA;EACA,cAAA;AAJJ","sourcesContent":[".TogetherActivityControlPage {\n  padding-left: 281px;\n  background: #eff0f4;\n  width: 100%;\n  min-height: 100vh;\n  box-sizing: border-box;\n\n  .titleBlock {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    padding: 43px 40px 27px;\n    box-sizing: border-box;\n\n    h1 {\n      margin: 0;\n      font-family: 'Montserrat Regular', sans-serif;\n      font-weight: 500;\n      font-size: 24px;\n      color: #2c274b;\n    }\n  }\n\n  &__content {\n    padding: 32px 40px 48px;\n    max-width: 1100px;\n  }\n\n  &__card {\n    background: #fff;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 1px 2px rgba(44, 39, 75, 0.06);\n  }\n\n  .ant-table {\n    font-size: 14px;\n  }\n\n  .ant-table-thead > tr > th {\n    font-weight: 600;\n    color: #2c274b;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TogetherActivityControlPage": `TogetherActivityControlPage`,
	"titleBlock": `titleBlock`,
	"TogetherActivityControlPage__content": `TogetherActivityControlPage__content`,
	"TogetherActivityControlPage__card": `TogetherActivityControlPage__card`,
	"ant-table": `ant-table`,
	"ant-table-thead": `ant-table-thead`
};
export default ___CSS_LOADER_EXPORT___;
